exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom[data-v-179d50ee] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 8;\n  background: #fff;\n}\n.media-zoom__close[data-v-179d50ee] {\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 1;\n}\n", ""]);

// exports
